// extracted by mini-css-extract-plugin
module.exports = {"container":"Toggle_container__9MAwN","thumb":"Toggle_thumb__NN0zG","on":"Toggle_on__pzMOT"};